export default __webpack_public_path__ + "static/media/vessel_status.f32cb7b9.svg";